var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { BaseService } from "app/views/base.service";
import { DataProvider2 } from "./provider/data2.provider";
import { of } from "rxjs";
import { map, switchMap } from "rxjs/operators";
var AuthService = /** @class */ (function (_super) {
    __extends(AuthService, _super);
    function AuthService(http, dp, router, location, activatedRoute) {
        var _this = _super.call(this, http) || this;
        _this.http = http;
        _this.dp = dp;
        _this.router = router;
        _this.location = location;
        _this.activatedRoute = activatedRoute;
        _this.userId = '';
        // TODO Тут явно копируются поля из модели User - заменить!
        _this.email = '';
        _this.username = '';
        _this.firstName = '';
        _this.lastName = '';
        _this.resources = {};
        _this.roles = [];
        _this.isAuth = false;
        _this.loading = false;
        // Мы отличаем два состояния доступа:
        // 1. isGranted - разрешен доступ в конкретный отдел/отчет
        // 2. isAnyGranted - разрешен доступ в статистика вообще
        // Такое разделение нужно, поскольку:
        // - если пользователь недопущен в статистику вообще, не показывать меню
        // - если допущен, но не везде - показывать меню
        // Как только сделаем нормальную навигацию, и динамический показ меню,
        // тогда можно будет убрать такое различие.
        _this.isGranted = false;
        _this.isAnyGranted = false;
        _this.isAdmin = false;
        _this.isProvider = false;
        _this.allowedResources = {};
        // @deprecate
        _this.path = '';
        return _this;
    }
    /**
     * MIGR
     * @returns {IUserInfo}
     */
    AuthService.prototype.getUser = function () {
        return this.dp.get('/get_user').pipe(map(function (r) { return r; }));
    };
    AuthService.prototype.checkGrantForRoute = function (route) {
        if (route === void 0) { route = ''; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, isAnyGranted, isGranted, roles, isAdmin, isProvider;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.dp.get('/access', { route: route }).toPromise()];
                    case 1:
                        _a = _b.sent(), isAnyGranted = _a.isAnyGranted, isGranted = _a.isGranted, roles = _a.roles, isAdmin = _a.isAdmin, isProvider = _a.isProvider;
                        this.isAnyGranted = isAnyGranted;
                        this.isGranted = isGranted;
                        this.roles = roles;
                        this.isAdmin = isAdmin;
                        this.isProvider = isProvider;
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthService.prototype.fetch = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, _a, isAuth, email, _id, username, firstName, lastName;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        me = this;
                        return [4 /*yield*/, me.getUser().toPromise()];
                    case 1:
                        _a = _b.sent(), isAuth = _a.isAuth, email = _a.email, _id = _a._id, username = _a.username, firstName = _a.firstName, lastName = _a.lastName;
                        me.userId = _id;
                        me.isAuth = isAuth;
                        me.email = email;
                        me.username = username;
                        me.firstName = firstName;
                        me.lastName = lastName;
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthService.prototype.loginByToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, httpOptions, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        httpOptions = {
                            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
                            withCredentials: true,
                        };
                        return [4 /*yield*/, me.http.get('https://ukit.com/admin/stat/jwt', httpOptions).toPromise()];
                    case 1:
                        token = (_a.sent()).token;
                        if (!token) {
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, me.dp.get('/login_by_token', {}, {
                                headers: new HttpHeaders({
                                    'Authorization': 'Bearer ' + token,
                                })
                            }).toPromise()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    AuthService.prototype.getAllowedResources = function () {
        return this.dp.get('/allowed_resources').pipe(map(function (data) { return Object.keys(data).reduce(function (obj, resourceName) {
            obj[resourceName] = !!data[resourceName];
            return obj;
        }, {}); }));
    };
    AuthService.prototype.fetchAllowedResources = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.getAllowedResources().toPromise()];
                    case 1:
                        _a.allowedResources = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthService.prototype.signOut = function () {
        var _this = this;
        return this.dp.get('/sign_out').pipe(switchMap(function () {
            _this.isAnyGranted = false;
            _this.isGranted = false;
            _this.roles = [];
            _this.isAdmin = false;
            _this.isProvider = false;
            _this.allowedResources = {};
            return of(_this.fetch());
        }));
    };
    AuthService.prototype.isAllowResource = function (resource) {
        return !!this.allowedResources[resource];
    };
    return AuthService;
}(BaseService));
export { AuthService };
